import CentralDto from './CentralDto'

export default class CentralAssignatedDto extends CentralDto {
    constructor(obj) {
        super(obj)
        this.siteCode = obj.siteCode
        this.situationDate = obj.situationDate
    }
}
